module.exports = __webpack_public_path__ + "media/images/game_icon/zh-tw/AB1529-4940702f79fe7d8fd89b2f5ea792b362.png";